import { createClient } from "@supabase/supabase-js"

// Use environment variables for database configuration
// Environment variables are REQUIRED - no fallback to client database
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Validate that environment variables are set
if (!supabaseUrl || !supabaseAnonKey) {
  const errorMsg = `Missing required environment variables:
    VITE_SUPABASE_URL: ${supabaseUrl ? '✅ Set' : '❌ Missing'}
    VITE_SUPABASE_ANON_KEY: ${supabaseAnonKey ? '✅ Set' : '❌ Missing'}
    
    Please ensure your .env file contains both variables and rebuild the application.`
  console.error(errorMsg)
  throw new Error(errorMsg)
}

// Log successful initialization (only in development)
if (import.meta.env.DEV) {
  console.log('✅ Supabase client initialized with URL:', supabaseUrl.substring(0, 30) + '...')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Types based on your database schema
export interface User {
  id: string
  phoneNo: string
  username:string
  created_at: string
}

export interface Admin {
  id: string
  phoneNo: string
  created_at: string
}
export interface Slot {
  id: string;
  date: string;
  time_start: string;
  time_end: string;
  status: "pending" | "approved" | "rejected" | "blocked";
  booked_by_user_id: string | null;
  booking_id: string | null;
  block_reason: string | null;
}



export interface TeamMember {
  id: string
  user_id: string
  name: string
  phone_number: string | null
}

export interface Booking {
  id: string
  user_id: string
  slot_id: string
  status: "pending" | "approved" | "rejected" |"blocked"
  team_members: Array<{ name: string; phone_number?: string }>
  created_at: string
   is_admin_booking: boolean
}



export interface TimeSlot {
  id: string;
  date: string;
  time_start: string;
  time_end: string;
  is_booked: boolean;
  booking_id?: string;
}      
export interface BookingWithDetails {
  id: string;
  user_id: string;
  slot_id: string;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled' | 'booked' | 'paid';
  team_members: Array<{ name: string; phone_number?: string }>;
  created_at: string;
  payment_id?: string | null;
  amount?: number | null;
  payment_status?: string | null;
  rejection_reason?: string | null;
  user: User;
  slot: Slot;
  admin_comment?: string | null;
}
export interface ActiveBooking {
  id: string;
  status: "pending" | "approved" | "rejected";
  slot: Slot;
}